import moment, { Moment } from 'moment';

export interface HallOfFamePlayerDTO {
	avatar: string | null;
	fullname: string;
}

export interface HallOfFameDTO {
	date_from: string;
	date_to: string;
	players: {
		highest_win_streak: (HallOfFamePlayerDTO & { current_win_streak: number }) | null;
		undefeated_champion: (HallOfFamePlayerDTO & { win_ratio: string }) | null;
		marathon_runner: (HallOfFamePlayerDTO & { battle_count: number }) | null;
	};
}

export interface HallOfFamePlayer {
	avatar: string | null;
	fullname: string;
}

export interface HallOfFamePlayers {
	highestWinStreak: (HallOfFamePlayer & { currentWinStreak: number }) | null;
	undefeatedChampion: (HallOfFamePlayer & { winRation: string }) | null;
	marathonRuner: (HallOfFamePlayer & { battleCount: number }) | null;
}

export default class HallOfFame {
	public readonly dateFrom: Moment;
	public readonly dateTo: Moment;
	public readonly players: HallOfFamePlayers;

	constructor(data: HallOfFameDTO) {
		this.dateFrom = moment(data.date_from);
		this.dateTo = moment(data.date_to);
		this.players = {
			highestWinStreak: data.players.highest_win_streak
				? {
						avatar: data.players.highest_win_streak.avatar,
						fullname: data.players.highest_win_streak.fullname,
						currentWinStreak: data.players.highest_win_streak.current_win_streak,
				  }
				: null,
			undefeatedChampion: data.players.undefeated_champion
				? {
						avatar: data.players.undefeated_champion.avatar,
						fullname: data.players.undefeated_champion.fullname,
						winRation: data.players.undefeated_champion.win_ratio,
				  }
				: null,
			marathonRuner: data.players.marathon_runner
				? {
						avatar: data.players.marathon_runner.avatar,
						fullname: data.players.marathon_runner.fullname,
						battleCount: data.players.marathon_runner.battle_count,
				  }
				: null,
		};
	}
}
